window.addEventListener('load', function () {
    var hash = window.location.hash.slice(1);
    if (!hash || !/^[a-zA-Z0-9_-]+$/.test(hash)) return;

    var trigger = document.querySelector('[data-expandable="' + hash + '"]');
    if (!trigger) return;

    trigger.click();

    setTimeout(function () {
        var top = trigger.getBoundingClientRect().top + window.pageYOffset - 400;
        window.scrollTo({ top: top, behavior: 'smooth' });
    }, 50);
});